/**
 * @description 词云react组件
 * @author daunjun
 */

import React, { Component, createRef, RefObject } from 'react';
import imageApi from '@umu/umu-image-handle';
import Cloud, { IWord } from './cloud';
import './wordCloud.scss';
import bgImg from './images/cloud_bg_color.png';
import bgGray from './images/cloud_bg_gray.png';

export type BackgroundType = 'grey' | 'color';

interface IWordCloudProps {
    words: IWord[];
    backgroundType: BackgroundType;
}

export default class WordCloud extends Component<IWordCloudProps, IWordCloudProps> {
    public containerRef: RefObject<HTMLDivElement> = createRef();

    public shouldComponentUpdate(nextProps: IWordCloudProps) {
        if (this.props.words !== nextProps.words) {
            return true;
        }
        return false;
    }

    public componentDidUpdate() {
        this.createCloud();
    }

    public createCloud() {
        const container: HTMLDivElement = this.containerRef.current as HTMLDivElement;
        const words = this.props.words || [];
        // const words = this.props.words.concat(this.props.words).concat(this.props.words).concat(this.props.words);
        // words.length = 20;
        const length = words.length;
        // 避免阻塞
        if (length > 20) {
            setTimeout(() => {
                return new Cloud(words, container);
            });
        } else {
            return new Cloud(words, container);
        }
        return true;
    }

    public componentDidMount() {
        this.createCloud();
    }

    public render() {
        const bgType = this.props.backgroundType;
        let bg;
        if (bgType === 'color') {
            bg = bgImg;
        } else {
            bg = bgGray;
        }
        const style = {
            background: `url(${imageApi.process(bg)}) no-repeat`,
            backgroundSize: 'contain',
        };
        return <div className="static-word-cloud" style={style} ref={this.containerRef} />;
    }
}
